// 클라우드 사이트(Cloudflare) API — 화면과 엔진 워커가 함께 쓴다.
// 같은 주소(origin)에서만 동작한다: PC 서버(127.0.0.1)나 Tailscale 주소에는 이 API 가 없어서 cloudMe() 가 null.

export interface CloudUser { id: string; name: string; provider: string; role: 'admin' | 'member' }
export interface CloudMe { cloud: true; providers: Record<string, boolean>; user: CloudUser | null }
export interface MailPage { batches: { id: number; device: string; blob: string }[]; more: boolean }

const at = (path: string) => new URL(path.replace(/^\//, ''), new URL('./', self.location.href)).href;

/** 클라우드 사이트인가 + 로그인한 사람. 클라우드가 아니면 null */
export async function cloudMe(): Promise<CloudMe | null> {
  try {
    const r = await fetch(at('api/cloud/me'), { cache: 'no-store', credentials: 'same-origin' });
    if (!r.ok) return null;
    const j = (await r.json()) as CloudMe | null;
    return j && j.cloud === true ? j : null;
  } catch {
    return null;
  }
}

export async function cloudCall<T>(method: string, path: string, body?: unknown): Promise<T> {
  const r = await fetch(at(path), {
    method,
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { 'X-APEX': '1', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const j = (await r.json().catch(() => null)) as (T & { detail?: string }) | null;
  if (!r.ok) throw new Error(j?.detail || `클라우드 응답 ${r.status}`);
  return j as T;
}

export const loginUrl = (provider: string, invite: string, extra = ''): string =>
  at(`auth/${provider}?${new URLSearchParams({ next: '/', ...(invite ? { invite } : {}) })}${extra}`);
export const logoutUrl = (): string => at('auth/logout');
